/* import __COLOCATED_TEMPLATE__ from './close-account-flow.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
let CloseAccountComponent = (_class = class CloseAccountComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "sfsAccountApi", _descriptor, this);
    _defineProperty(this, "page", 'prompt');
    _defineProperty(this, "selectedExternalAccount", void 0);
  }
  init(...args) {
    super.init(...args);
    if (this.externalBankAccounts.length > 0) {
      set(this, 'selectedExternalAccount', this.externalBankAccounts[0]);
    }
  }
  confirm() {
    return this.sfsAccountApi.closeAccount(this.primaryAccount.id, this.selectedExternalAccount.id).then(() => {
      set(this, 'page', 'success');
    });
  }
  goToExternalAccountSelection() {
    if (this.externalBankAccounts.length > 0) {
      set(this, 'page', 'external-account');
    } else {
      set(this, 'page', 'add-external-account');
    }
  }
  selectNewExternalAccount(externalAccount) {
    this.selectExternalAccount(externalAccount);
    set(this, 'page', 'confirm');
  }
  selectExternalAccount(externalAccount) {
    set(this, 'selectedExternalAccount', externalAccount);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sfsAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToExternalAccountSelection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToExternalAccountSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectNewExternalAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectNewExternalAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectExternalAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectExternalAccount"), _class.prototype), _class);
export { CloseAccountComponent as default };